import digital_logo from "../../../public_images/digital-logo.svg"
import digital_ai from "../../../public_images/DubaiAI.svg"
import accessibility_icon from "../../../public_images/icn-complaints.svg"
import happy_icon from "../../../public_images/icn-happy.svg"
import chat_icn from "../../../public_images/icn-chat_bubble_outline.svg"
import grid_view from "../../../public_images/icn-grid-view.svg"
import dubai_ae from "../../../public_images/DubaiAE.svg"
import dubai_ae_icon from "../../../public_images/DdiabiAE-icon.svg"

export default {
  title: 'Components/Sticky Footer',
  tags: ['autodocs'],
  argTypes: {
    hideMiddleSection: {
      control: { type: 'boolean' },
      description: 'Hides the middle section of the footer',
    },
    onclick:{
      control: { type: 'text' },
      description: 'event handler for button',
    },
  },
  component: 'dda-sticky-footer',
  parameters: {
    docs: {
      description: {
        component: 'Sticky footer with configurable props.',
      },
    },
  },
};

const Template = args => `
  <dda-sticky-footer
    happiness-icon-href="${args.happinessIconHref}"
    happiness-icon-id="${args.happinessIconId}"
    happiness-icon-src="${args.happinessIconSrc}"
    happiness-icon-alt="${args.happinessIconAlt}"
    happiness-icon-tooltip="${args.happinessIconTooltip}"
    happiness-icon-click="${args.happinessIconClick}"

    accessibility-icon-href="${args.accessibilityIconHref}"
    accessibility-icon-Id="${args.accessibilityIconId}"
    accessibility-icon-src="${args.accessibilityIconSrc}"
    accessibility-icon-alt="${args.accessibilityIconAlt}"
    accessibility-icon-tooltip="${args.accessibilityIconTooltip}"
    accessibility-icon-click="${args.accessibilityIconClick}"

    services-icon-href="${args.servicesIconHref}"
    services-icon-Id="${args.servicesIconId}"
    services-icon-src="${args.servicesIconSrc}"
    services-icon-alt="${args.servicesIconAlt}"
    services-icon-tooltip="${args.servicesIconTooltip}"
    services-icon-text="${args.servicesIconText}"
    services-icon-click="${args.servicesIconClick}"

    hide-middle-section="${args.hideMiddleSection}"
    middle-link='${JSON.stringify(args.middleLink)}'

    right-link='${JSON.stringify(args.rightLink)}'

    dubaiae-icon-href="${args.dubaiaeIconHref}"
    dubaiae-icon-Id="${args.dubaiaeIconId}"
    dubaiae-icon-src="${args.dubaiaeIconSrc}"
    dubaiae-icon-small-src="${args.dubaiaeIconSmallSrc}"
    dubaiae-icon-alt="${args.dubaiaeIconAlt}"
    dubaiae-icon-tooltip="${args.dubaiaeIconTooltip}"
    dubaiae-icon-on-click="${args.dubaiaeIconOnClick}"

    ai-icon-href="${args.aiIconHref}"
    ai-icon-Id="${args.aiIconId}"
    ai-icon-src="${args.aiIconSrc}"
    ai-icon-alt="${args.aiIconAlt}"
    ai-icon-tooltip="${args.aiIconTooltip}"
    ai-icon-on-click="${args.aiIconOnClick}"

    chat-icon-href="${args.chatIconHref}"
    chat-icon-Id="${args.chatIconId}"
    chat-icon-src="${args.chatIconSrc}"
    chat-icon-alt="${args.chatIconAlt}"
    chat-icon-tooltip="${args.chatIconTooltip}"
    chat-icon-on-click="${args.chatIconClick}"

    more-icon-family="${args.moreIconFamily}"
    more-icon="${args.moreIcon}"
    
  ></dda-sticky-footer>
`;

export const Default = Template.bind({});
Default.args = {
  happinessIconHref: 'javascript:void(0)',
  happinessIconId: 'Happiness',
  happinessIconSrc: happy_icon,
  happinessIconAlt: 'Happiness',
  happinessIconTooltip: 'Happiness',
  happinessIconClick: "console.log('Happiness icon clicked')",

  accessibilityIconHref: 'javascript:void(0)',
  accessibilityIconId: 'uggestionsComplaints',
  accessibilityIconSrc: accessibility_icon,
  accessibilityIconAlt: 'Suggestions and complaints',
  accessibilityIconTooltip: 'Suggestions & complaints',
  accessibilityIconClick: "console.log('Suggestion AE icon clicked')",

  servicesIconHref: 'javascript:void(0)',
  servicesIconId: 'footerServices',
  servicesIconSrc: grid_view,
  servicesIconAlt: 'Services',
  servicesIconTooltip: 'Services',
  servicesIconText: 'Services',
  servicesIconClick: "console.log('Services icon clicked')",

  hideMiddleSection: false,
  
  middleLink: [
      { LogoTooltip: "Middlelink", href: "javascript:void(0)", src: digital_logo, alt: "DDA" },
      { LogoTooltip: "Middlelink", href: "javascript:void(0)", src: digital_logo, alt: "DDA" },
      { LogoTooltip: "Middlelink", href: "javascript:void(0)", src: digital_logo, alt: "DDA" },
  ],

  rightLink: [
      { RightLinkTooltip: "Survey", href: "javascript:void(0)", title: "Survey", itemId: "itemID", ariaLabel: "Survey", LinkText: "Survey", IconFamily: "material-icons", IconName:"poll" },
      { RightLinkTooltip: "Locations", href: "javascript:void(0)", title: "Locations", itemId: "itemID", ariaLabel: "Locations", LinkText: "Locations", IconFamily: "material-icons", IconName:"location_on" },
      { RightLinkTooltip: "News Room", href: "javascript:void(0)", title: "News Room", itemId: "itemID", ariaLabel: "News Room", LinkText: "News Room", IconFamily: "material-icons", IconName:"feed" },
      { RightLinkTooltip: "Contact Us", href: "javascript:void(0)", title: "Contact Us", itemId: "itemID", ariaLabel: "Contact Us", LinkText: "Contact Us", IconFamily: "material-icons", IconName:"mail" },
  ],

  dubaiaeIconHref: 'javascript:void(0)',
  dubaiaeIconId: 'dubaiAEID',
  dubaiaeIconSrc: dubai_ae,
  dubaiaeIconSmallSrc: dubai_ae_icon,
  dubaiaeIconAlt: 'dubai-ae',
  dubaiaeIconTooltip: 'dubai.ae',
  dubaiaeIconOnClick: "console.log('Dubai AE icon clicked')",

  aiIconHref: 'javascript:void(0)',
  aiIconId: 'aiIconID',
  aiIconSrc: digital_ai,
  aiIconAlt: 'Digital AI',
  aiIconTooltip: 'Digital AI',
  aiIconOnClick: "console.log('AI icon clicked')",

  chatIconHref: 'javascript:void(0)',
  chatIconId: 'chatID',
  chatIconSrc: chat_icn,
  chatIconAlt: 'Online Chat',
  chatIconTooltip: 'Online Chat',
  chatIconOnClick: "console.log('Chat icon clicked')",
  moreIconFamily: 'material-icons',
  moreIcon: 'more_horiz',
  chatIconClick: "console.log('Chat Icon clicked')",

};
